export const imageNames = [
    "CAIE MF19 THE NORMAL DISTRIBUTION FUNCTION.png",
    "CAIE MF19 Critical values for the normal distribution.png",
    "CAIE MF19 CRITICAL VALUES FOR THE t-DISTRIBUTION.png",
    "CAIE MF19 CRITICAL VALUES FOR THE chisquare-DISTRIBUTION.png",
    "CAIE MF19 WILCOXON SIGNED-RANK TEST.png",
    "CAIE MF19 WILCOXON RANK-SUM TEST.png",
    "EDEXCEL Critical Values For Correlation Coefficients.png",
    "EDEXCEL Percentage Points Of The Chisquare Distribution Function.png",
    "EDEXCEL Poisson Cumulative Distribution Function.png",
    "EDEXCEL Binomial Cumulative Distribution Function Table 1.png",
    "EDEXCEL Binomial Cumulative Distribution Function Table 2.png",
    "EDEXCEL Binomial Cumulative Distribution Function Table 3.png",
    "EDEXCEL Binomial Cumulative Distribution Function Table 4.png",
    "EDEXCEL Binomial Cumulative Distribution Function Table 5.png",
    "EDEXCEL The Normal Distribution Function.png"
]